import { render, staticRenderFns } from "./viewInvoice.vue?vue&type=template&id=a95bc152&scoped=true"
import script from "./viewInvoice.vue?vue&type=script&lang=js"
export * from "./viewInvoice.vue?vue&type=script&lang=js"
import style0 from "./viewInvoice.vue?vue&type=style&index=0&id=a95bc152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95bc152",
  null
  
)

export default component.exports